import StateContext from 'src/context/UserProvider';
import ErrorService, { EDPError } from "src/services/Error.service";

type LangServiceType = {
	setLangOfTheLoguedUser: (lang: string) => Promise<string>
}

export function LanguageService(): LangServiceType {
  const { user, lang } = StateContext();

  // Set language of the logued user
  const setLangOfTheLoguedUser = (language: string): Promise<string> => {
    const _userId: number = user?.id || 0;
    const _email: string = user?.email || '';

    return new Promise(
      (resolve, reject) => {
        if (_userId === 0 || _email === '') {
          ErrorService(
            new EDPError(
              "LanguageService - setLangOfTheLoguedUser - The registered user is not valid",
              "error"
            )
          );
          reject('The registered user is not valid');
        }
        // Si el idioma es igual al seteado s�lo retorno sin llamar la base de datos.
        if (lang === language) resolve(language)

        fetch(
          '/api/user/lang',
          {
            method: "PUT",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Accept": 'application/json',
              "Authorization": `${_email}`,
              "Validation": `${_userId}`,
              "Lang": `${language}`
            }
          }
        ).then(
          response => {
            if (response.status === 204) resolve(language);
            else if (
              response.status === 400 ||
              response.status === 401 ||
              response.status === 404
            ) {
              reject(response.statusText);
            }
          }
        ).catch(
          error => {
            reject(`${error.message}`);
          }
        );
      }
    );
  }

  return {
    setLangOfTheLoguedUser
  }
}

